import lock from '../utils/scroll-lock';

const dom = {};

const selectors = {
  body: '.page-modal-body',
  close: '.page-modal-close',
  header: '.page-modal-header h2',
  modal: '.page-modal',
  trigger: '[data-page-modal-trigger]',
};

const cacheDom = () => {
  dom.modal = document.querySelector(selectors.modal);
  dom.modal && (dom.header = dom.modal.querySelector(selectors.header));
  dom.modal && (dom.body = dom.modal.querySelector(selectors.body));
  dom.modal && (dom.triggers = document.querySelectorAll(selectors.trigger));
  dom.modal && (dom.closes = document.querySelectorAll(selectors.close));
};

const bindEvents = () => {
  dom.modal &&
    dom.modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('page-modal-inner')) closeModal(modal);
    });
  dom.triggers &&
    dom.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        if (!trigger.dataset.handle) return;
        fetch(`/pages/${trigger.dataset.handle}.json`)
          .then((blob) => blob.json())
          .then(({ page }) => {
            dom.header.innerText = page.title ?? '';
            dom.header.ariaLabel = page.title ?? '';
            dom.body.innerHTML = page.body_html ?? '';
            openModal();
          });
      });
    });
  dom.closes &&
    dom.closes.forEach((close) => {
      close.addEventListener('click', (e) => closeModal());
    });
};

const openModal = () => {
  if (!dom.modal) return;
  dom.modal.classList.remove('hidden');
  setTimeout(() => {
    dom.modal.classList.remove('opacity-0');
    // setTimeout(() => lock.enable(), 100)
    document.documentElement.style.overflow = 'hidden';
  }, 10);
};

const closeModal = () => {
  // lock.disable()
  document.documentElement.style.overflow = 'auto';
  dom.modal.classList.add('opacity-0');
  setTimeout(() => {
    dom.modal.classList.add('hidden');
  }, 100);
};

const pageModal = {
  init() {
    cacheDom();
    bindEvents();
  },
};

export default pageModal;
